import { render, staticRenderFns } from "./ActionsBar.vue?vue&type=template&id=4b549bc8&"
import script from "./ActionsBar.vue?vue&type=script&lang=js&"
export * from "./ActionsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b549bc8')) {
      api.createRecord('4b549bc8', component.options)
    } else {
      api.reload('4b549bc8', component.options)
    }
    module.hot.accept("./ActionsBar.vue?vue&type=template&id=4b549bc8&", function () {
      api.rerender('4b549bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/components/ActionsBar/ActionsBar.vue"
export default component.exports